import * as THREE from "three";

// Cities we need for the Earth transition.
// lat / lng / little label that the scene can show.
export const CITIES = {
  tokyo:  { lat: 35.7,  lng: 139.7, label: "Tokyo" },
  noida:  { lat: 28.5,  lng: 77.4, label: "Noida" },
  // family home towns, used on ?side=groom
  patna:  { lat: 25.6,  lng: 85.1, label: "Patna" },
  kanpur: { lat: 26.5,  lng: 80.3, label: "Kanpur" },
  jaipur: { lat: 26.9,  lng: 75.8, label: "Jaipur" },
};

/**
 * Convert (lat, lng) on a unit sphere to a THREE.Vector3.
 * `r` lets callers lift a point slightly above the surface (for markers).
 */
export function latLngToVec3(lat, lng, r = 1.02) {
  const phi = ((90 - lat) * Math.PI) / 180;
  const theta = ((lng + 180) * Math.PI) / 180;
  return new THREE.Vector3(
    -r * Math.sin(phi) * Math.cos(theta),
     r * Math.cos(phi),
     r * Math.sin(phi) * Math.sin(theta)
  );
}

/**
 * Build a cubic Bezier curve that arcs above the surface between two
 * surface points. `lift` = how high the arc rises.
 */
export function arcCurve(a, b, lift = 1.35) {
  const midA = a.clone().add(b).multiplyScalar(0.5).normalize().multiplyScalar(lift);
  const midB = a.clone().add(b).multiplyScalar(0.5).normalize().multiplyScalar(lift);
  return new THREE.CubicBezierCurve3(a, midA, midB, b);
}
